<canvas class="canvas" #canvas></canvas>
<ng-content></ng-content>
<div class="document-wrapper">
  <img *ngIf="imageSrc$ | async as src" class="page" [src]="src">
</div>
